import React from "react";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {Provider as JotaiProvider} from "jotai";
import {Box, Spinner} from "@amzn/awsui-components-console";
import App from "./components/pages/App";
import AppInitWrapper from "./components/AppInitWrapper";
import {Authenticate} from "./components/atoms";
import "./index.scss";

// Apply AWS UI theme
document.body.classList.add("awsui-visual-refresh", "awsui-visual-refresh-app");
// applyMode(Mode.Dark);

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <React.StrictMode>
      <JotaiProvider>
        <BrowserRouter>
          <AppInitWrapper>
            <React.Suspense
                fallback={
                  <Box textAlign="center" margin={{vertical: "xxxl"}}>
                    <Spinner size="large"/>
                  </Box>
                }
            >
              <Authenticate>
                <App/>
              </Authenticate>
            </React.Suspense>
          </AppInitWrapper>
        </BrowserRouter>
      </JotaiProvider>
    </React.StrictMode>
);
